<div class="full-width">
    <div class="btn-group mr-2 full-width"
         role="group"
         aria-label="First group">
        <button
                class="no-border pl-0 full-width"
                title="Izaberi vrstu zadatka"
                [matMenuTriggerFor]="types"
                mat-stroked-button>
            <mat-icon class="tt-icon">grading</mat-icon>
            {{buttonText}}
        </button>

        <button *ngIf="isSelected===true"
                (click)="clearData()" type="button" class="btn  shadow-none">
            <mat-icon class="tt-action-button">close</mat-icon>
        </button>
        <button type="button"
                class="btn shadow-none"
                [title]="addingPermission===false? 'Potrebna je dozvola za dodavanje novih vrsta.':'Dodajte novu vrstu zadatka'"
                *ngIf="!isSelected"
                (click)="openDialog()">
            <mat-icon class="tt-action-button">add</mat-icon>
        </button>

    </div>


    <mat-menu [overlapTrigger]="false" #types="matMenu">
        <div class="tt-pl-15" (click)="$event.stopPropagation()">
            <input
                    [(ngModel)]="searchText"
                    class="form-control tt-placeholdericon"
                    placeholder="&#xe8b6; Pretraži"
                    type="text">
        </div>
        <div>
            <section class="tt-section-menu">
                <span>
    <ul class="tt-pl-15">
      <li *ngFor="let item of userTypes | searchPipe:searchText:'name'">
        <section class="tt-options">
  <mat-option (click)="buttonText=item.name;getType(item)"
              class="full-width">{{item.name}}</mat-option>
</section>
      </li>
    </ul>
  </span>
            </section>
        </div>
    </mat-menu>

</div>







